import React from "react";
import PaymentPageSection from "../../Sections/PaymentPageSection/Content";
const PaymentPage = () => {
  return <PaymentPageSection />;
};

export default PaymentPage;
